/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassInstanceDTO,
  ClassInstanceDTOOptional,
  ClassInstanceDTOMetaI,
  ClassInstanceDTOTrackedI,
} from "./class-instance-dto";
import {
  ClassInstanceDTOTracked,
  ClassInstanceDTOMeta,
} from "./class-instance-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonClassEligibility,
  PersonClassEligibilityOptional,
  PersonClassEligibilityMetaI,
  PersonClassEligibilityTrackedI,
} from "./person-class-eligibility";
import {
  PersonClassEligibilityTracked,
  PersonClassEligibilityMeta,
} from "./person-class-eligibility";

/**
 *
 * @export
 * @interface ClassWithEligibilitySingularDTO
 */
export interface ClassWithEligibilitySingularDTOOptional {
  /**
   *
   * @type {ClassInstanceDTO}
   * @memberof ClassWithEligibilitySingularDTO
   */
  classInstance?: ClassInstanceDTOOptional;
  /**
   *
   * @type {PersonClassEligibility}
   * @memberof ClassWithEligibilitySingularDTO
   */
  personEligibility?: PersonClassEligibilityOptional;
}

export interface ClassWithEligibilitySingularDTO extends ClassWithEligibilitySingularDTOOptional {
  /**
   *
   * @type {ClassInstanceDTO}
   * @memberof ClassWithEligibilitySingularDTO
   */
  classInstance: ClassInstanceDTO;
  /**
   *
   * @type {PersonClassEligibility}
   * @memberof ClassWithEligibilitySingularDTO
   */
  personEligibility: PersonClassEligibility;
}

export interface ClassWithEligibilitySingularDTOTrackedI {
  /**
   *
   * @type {ClassInstanceDTO}
   * @memberof ClassWithEligibilitySingularDTO
   */
  classInstance?: ClassInstanceDTOTrackedI;
  classInstanceIsSet: boolean;
  /**
   *
   * @type {PersonClassEligibility}
   * @memberof ClassWithEligibilitySingularDTO
   */
  personEligibility?: PersonClassEligibilityTrackedI;
  personEligibilityIsSet: boolean;
}

transformDatesMap.set(
  "ClassWithEligibilitySingularDTO",
  function (model: ClassWithEligibilitySingularDTO) {
    const transformDatesclassInstance =
      transformDatesMap.get("ClassInstanceDTO");
    if (transformDatesclassInstance && model.classInstance) {
      transformDatesclassInstance(model.classInstance);
    }
    const transformDatespersonEligibility = transformDatesMap.get(
      "PersonClassEligibility",
    );
    if (transformDatespersonEligibility && model.personEligibility) {
      transformDatespersonEligibility(model.personEligibility);
    }
  },
);

export type ClassWithEligibilitySingularDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  classInstance: PropertyMeta<ClassInstanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  personEligibility: PropertyMeta<PersonClassEligibilityMetaI>;
}>;

export var ClassWithEligibilitySingularDTOMeta: ClassWithEligibilitySingularDTOMetaI =
  {} as ClassWithEligibilitySingularDTOMetaI;
ClassWithEligibilitySingularDTOMeta = typeMeta(
  "ClassWithEligibilitySingularDTO",
  {
    classInstance: propertyMeta(
      "classInstance",
      false,
      true,
      false,
      ClassInstanceDTOMeta,
    ),
    personEligibility: propertyMeta(
      "personEligibility",
      false,
      true,
      false,
      PersonClassEligibilityMeta,
    ),
  },
);

const metaI = ClassWithEligibilitySingularDTOMeta;

registerMeta(() => {});

export class ClassWithEligibilitySingularDTOTracked implements ClassWithEligibilitySingularDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  classInstance__I?: ClassInstanceDTOTracked = undefined;
  classInstanceIsSet: boolean = false;
  set classInstance(v: undefined | ClassInstanceDTOTracked) {
    if (v !== undefined) {
      this.classInstance__I = v;
      this.classInstanceIsSet = true;
    } else {
      this.classInstance__I = v || undefined;
      this.classInstanceIsSet = true;
    }
    this.changeTracker = true;
  }
  get classInstance() {
    return this.classInstance__I;
  }
  personEligibility__I?: PersonClassEligibilityTracked = undefined;
  personEligibilityIsSet: boolean = false;
  set personEligibility(v: undefined | PersonClassEligibilityTracked) {
    if (v !== undefined) {
      this.personEligibility__I = v;
      this.personEligibilityIsSet = true;
    } else {
      this.personEligibility__I = v || undefined;
      this.personEligibilityIsSet = true;
    }
    this.changeTracker = true;
  }
  get personEligibility() {
    return this.personEligibility__I;
  }
  constructor(
    config?: ClassWithEligibilitySingularDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.classInstance?.setIds();

    this.personEligibility?.setIds();
  }
  assignFrom(
    config: ClassWithEligibilitySingularDTOOptional,
    options?: AssignOptions,
  ): ClassWithEligibilitySingularDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.classInstance &&
      this.classInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.classInstance = new ClassInstanceDTOTracked(
        config.classInstance,
        options,
      );
      if (optionsRequired.unassign) this.classInstanceIsSet = false;
      else this.classInstanceIsSet = true;
    }
    if (
      config.personEligibility &&
      this.personEligibilityApplyFilter(optionsRequired.filter)
    ) {
      this.personEligibility = new PersonClassEligibilityTracked(
        config.personEligibility,
        options,
      );
      if (optionsRequired.unassign) this.personEligibilityIsSet = false;
      else this.personEligibilityIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(
    filter?: FilterVarsType,
  ): ClassWithEligibilitySingularDTOTrackedI {
    const cloned = {} as ClassWithEligibilitySingularDTOTrackedI;
    if (
      this.classInstanceIsSetDeep() &&
      this.classInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classInstanceIsSet = true;
      cloned.classInstance = this.classInstance?.removeUnset(filter);
    } else {
      //cloned.classInstanceIsSet = false
    }
    if (
      this.personEligibilityIsSetDeep() &&
      this.personEligibilityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personEligibilityIsSet = true;
      cloned.personEligibility = this.personEligibility?.removeUnset(filter);
    } else {
      //cloned.personEligibilityIsSet = false
    }
    return cloned;
  }
  unassignAll(
    filter?: FilterVarsType,
  ): ClassWithEligibilitySingularDTOTrackedI {
    if (!this.classInstanceApplyFilter(filter)) this.classInstanceIsSet = false;
    this.classInstance?.unassignAll(filter);

    if (!this.personEligibilityApplyFilter(filter))
      this.personEligibilityIsSet = false;
    this.personEligibility?.unassignAll(filter);

    return this;
  }
  classInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassWithEligibilitySingularDTOMeta.classInstance,
      ClassWithEligibilitySingularDTOMeta,
      this.classInstance,
      this,
    );
  }
  classInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classInstanceIsSet && this.classInstanceApplyFilter(filter))
      return true;
    return this.classInstance?.anySet(filter) == true;

    return false;
  }
  personEligibilityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassWithEligibilitySingularDTOMeta.personEligibility,
      ClassWithEligibilitySingularDTOMeta,
      this.personEligibility,
      this,
    );
  }
  personEligibilityIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.personEligibilityIsSet &&
      this.personEligibilityApplyFilter(filter)
    )
      return true;
    return this.personEligibility?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.classInstanceIsSetDeep(filter)) return true;
    if (this.personEligibilityIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
